import { Controller } from "@hotwired/stimulus";

// Swaps option-group labels under Branding between the group's regular `name`
// and the admin-configured `alternative_name`, based on the "The fonts will be
// used for" radio selection ("client" vs "me").
//
// Each target label carries:
//   data-name              -> default label (used for "client")
//   data-alternative-name  -> alternate label (used for "me"), optional
export default class extends Controller {
  static targets = ["label", "clientField"];

  connect() {
    this.onChange = () => this.apply();

    this.radios = this.element.querySelectorAll('input[name="license_usage"]');
    this.radios.forEach((radio) => {
      radio.addEventListener("change", this.onChange);
    });

    this.apply({ isInitial: true });
  }

  disconnect() {
    this.radios.forEach((radio) => {
      radio.removeEventListener("change", this.onChange);
    });
  }

  apply({ isInitial = false } = {}) {
    this.updateLabels({ isInitial });
  }

  updateLabels({ isInitial = false } = {}) {
    console.log("license-usage-label updateLabels", this.element);
    const selected = this.element.querySelector(
      'input[name="license_usage"]:checked'
    );
    // `selected` can be null on initial page load when neither radio is pre-checked.
    const clientSelected = selected?.value === "client";
    const meSelected = selected?.value === "me";

    this.labelTargets.forEach((el) => {
      const name = el.dataset.name ?? "";
      const alternativeName = el.dataset.alternativeName ?? "";
      el.textContent = meSelected && alternativeName ? alternativeName : name;
    });

    if (this.hasClientFieldTarget) {
      // The client name field is only relevant when the fonts are used for a client.
      this.clientFieldTarget.hidden = !clientSelected;
      if (!clientSelected) {
        this.clientFieldTarget.value = "";
      } else if (!isInitial) {
        this.clientFieldTarget.focus();
      }
    }
  }
}
